import { createClient } from '@supabase/supabase-js';

/** Master HQ (elitewebforge-commander-hq) — shared DHC / Cheep / Navi project */
const DEFAULT_SHARED_PROJECT_ID = 'sdnbxlttdpajjghkiwhf';
const DEFAULT_SHARED_SUPABASE_URL = `https://${DEFAULT_SHARED_PROJECT_ID}.supabase.co`;

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  process.env.NEXT_PUBLIC_SUPABASE_URL ||
  DEFAULT_SHARED_SUPABASE_URL;

const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  '';

let client = null;

export function getSharedSupabaseClient() {
  if (client) return client;
  if (!supabaseUrl || !supabaseAnonKey) return null;
  client = createClient(supabaseUrl, supabaseAnonKey);
  return client;
}

export const sharedSupabase = getSharedSupabaseClient();
